// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-p3QaI";
var _4 = "inner-JxYJ4";
var _5 = "leftSlot-16QJm";
var _6 = "centerSlot-2KLi6";
var _7 = "rightSlot-3LeV3";
var _8 = "equalSlotsBasis-1REzQ";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "inner", _5 as "leftSlot", _6 as "centerSlot", _7 as "rightSlot", _8 as "equalSlotsBasis" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "inner": _4, "leftSlot": _5, "centerSlot": _6, "rightSlot": _7, "equalSlotsBasis": _8 }
